import React from 'react';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import Copyright from './furniture/Copyright'
import {useStyles}from './furniture/Dashboard-Config'
import AppBarAndDrawer from './furniture/AppBarAndDrawer'

import TreeMapCard from './treemap/Treemapcard'

import { useOvermind } from '../overmind';
import NewSessionLoader from './accountSelection/NewSessionLoader'



export default function Utilization() {
  const classes = useStyles();
  const { state, actions } = useOvermind();

  if(state.blockAccess){
    actions.updateFlag({'name':'redirectPath','payload':'/utilization'});
    return(<NewSessionLoader/>);
  }else{
    return (
      <div className={classes.root}>
        <AppBarAndDrawer/>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={2}>

            {/* Placeholder */}
            <Grid item xs={12} md={12} lg={12}>
            <Paper className={classes.paper}>
              <Typography variant="h6" color="primary" gutterBottom >
                Custom Javascript Utilization
              </Typography>
              <Typography variant="body1"  gutterBottom >
                GTM Docs - Custom Javascript Utilization gives you insight on how much Custom HTML Tags and Custom Javascript Variables are being used in comparison to all the Tags, Triggers, and Variables in your container.
                The Utilization features highlights the use of Custom Tags and Variables, because while useful, they need to be used sparingly to keep container sizes under control.
              </Typography>
            </Paper>
            </Grid>

            {/* Explore Graph*/}
            <Grid item xs={12}>
              <Paper>
                <TreeMapCard />
              </Paper>
            </Grid>


            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>
    );
  }
}
